import {AbstractControl, FormGroup, NgForm} from '@angular/forms';
import {
    AfterContentInit, Component, ContentChildren, ElementRef, EventEmitter, Input, Output, QueryList,
    Renderer2
} from '@angular/core';
import {FieldMessage} from './field.message';
import {FieldMessageI} from './field.message.i';

@Component({
    selector: 'field-validator',
    template: require('./field.error.html')
})
export class FieldValidator implements AfterContentInit {

    @Input('for') public controlAlias: string;

    @Output('stateChanged') stateChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

    @ContentChildren(FieldMessage) messages: QueryList<FieldMessageI>;

    submitted: boolean = false;

    public control: AbstractControl;

    constructor(private element: ElementRef, private renderer: Renderer2, private ngForm: NgForm) {
    }

    public setControl(control: AbstractControl) {
        if (!control || !!this.control) {
            return;
        }
        this.control = control;
        this.updateView(control);//init view
        this.control.valueChanges.subscribe(() => {
            this.updateView(this.control);
        });
        //adding/removing error class for form-group
        this.stateChanged.subscribe(state => {
            let parent = this.element.nativeElement.closest('.form-group');
            if (parent && state) {
                this.renderer.addClass(parent, 'has-error');
            } else {
                this.renderer.removeClass(parent, 'has-error');
            }
        });
    }

    public setSubmitted(isSubmitted: boolean) {
        this.submitted = isSubmitted;
        this.stateChanged.emit(this.getVisibilityState());
    }

    public updateView(control: AbstractControl) {
        let type = FieldValidator.readControlErrorType(control.errors);
        this.messages.forEach((message: FieldMessage) => {
            message.setOpen(message.messageType === type);
        });
        this.stateChanged.emit(this.getVisibilityState());
    }

    public getVisibilityState(): boolean {
        return !(!!this.control ? !(!this.control.valid && !!this.control.errors && (this.control.touched || this.submitted)) : true)
    }

    private static readControlErrorType(errorsMap: Object) {
        let type;
        if (errorsMap) {
            type = Object.keys(errorsMap)[0];
        }
        return type;
    };

    ngAfterContentInit() {
        setTimeout(() => {
            this.setControl(this.findControlInGroup(this.ngForm.form, this.controlAlias));
        });

        this.ngForm.ngSubmit.subscribe(() => {
            this.setSubmitted(this.ngForm.submitted);
        })
    }

    private findControlInGroup(g: FormGroup, controlAlias: string): AbstractControl {
        let result = g.controls[controlAlias];
        if (result) {
            return result;
        }
        let controlAliases = Object.keys(g.controls);
        for (let i = 0; i < controlAliases.length; i++) {
            if (g.controls[controlAliases[i]] instanceof FormGroup) {
                return this.findControlInGroup(<FormGroup>g.controls[controlAliases[i]], controlAlias);
            }
        }
        return result;
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/validation/field.validator.ts